export function convertPxToRem(px: number): number {
   const baseFontSize = 16; 
   const rem = px / baseFontSize;
   return rem;
 }
 